// DEPENDENCIES
//// Local
import { IRule } from "../../models/rule.interface";


export interface IRuleState {
  templates: IRule[];
}

export const initialRuleState: IRuleState = {
  templates: []
}
